const moment = require('moment-timezone');

export default {
  methods: {
    mapPCareDashboardPatients(source) {
      return source.map((item, index) => {
        return {
          id: item.id,
          no: (this.pagination.page - 1) * this.itemsPerPage + index + 1,
          datein: moment(item.date_in).format('DD-MM-YYYY'),
          dateout: moment(item.date_out).format('DD-MM-YYYY'),
          name: item.name || '-',
          rmNumber: item.medical_record_number || '-',
          bpjs: item.assurance_number || '-',
          nik: item.nik_number || '-',
          bridgingStatus: this.bridgingStatusPCare(item),
          idRegistration: item.id_registration,
          poly: item.unit,
        };
      });
    },
    bridgingStatusPCare(value) {
      if (value.bridging_status === 'success') {
        return moment(value.last_update).format('DD-MM-YYYY');
      } else if (value.bridging_status === 'pending') {
        return 'Diproses';
      } else {
        return {
          status: 'Gagal',
          message: value.error.join(', '),
        };
      }
    },
  },
};
